export const safeNav = (url: string) => {
  if (window.location.pathname !== url) {
    window.location.href = url;
  }
};

/** 当前 pathname 是否在 /login 系列路径上 */
const isOnLoginPath = (): boolean => {
  const p = window.location.pathname;
  return p === '/login' || p.startsWith('/login/');
};

/**
 * 计算回跳 next：
 * - ignoreNext=false 时直接返回 '/'
 * - 已经在 /login 上时，从 search 中取出原始 next，避免 /login?next=/login?next=... 嵌套累积
 * - 否则使用当前 pathname + search
 */
const computeNext = (ignoreNext: boolean): string => {
  if (!ignoreNext) return '/';
  if (isOnLoginPath()) {
    const existing = new URLSearchParams(window.location.search).get('next');
    return existing || '/';
  }
  return window.location.pathname + window.location.search;
};

export const safeToLogin = (ignoreNext: boolean = true) => {
  const next = computeNext(ignoreNext);

  // project-admin 平台没有前端 /login 页面，统一走 RBAC
  const goRbac =
    (import.meta as any).env?.VITE_PLATFORM === 'project-admin' ||
    window.location.pathname.startsWith('/tiangong');

  if (goRbac) {
    const target =
      window.location.origin + (next.startsWith('/') ? next : `/${next}`);
    window.location.href = `/rbac/login?next=${encodeURIComponent(target)}`;
  } else {
    safeNav(`/login?next=${encodeURIComponent(next)}`);
  }
};
